@if (selectable()) {
	@if (preventSelection()) {
		<div
			class="listItem preventSelection"
			[class.highlight]="selected()"
			[class.invalid]="invalid()"
			[matTooltip]="tooltip()"
			matTooltipClass="warn"
		>
			<div class="selectionIndicator" [class.visible]="selected()"></div>
			<ng-container *ngTemplateOutlet="content" />
		</div>
	} @else {
		<div
			class="listItem selectable"
			(click)="onClick.emit()"
			[class.highlight]="selected()"
			[class.invalid]="invalid()"
			[matTooltip]="tooltip()"
			matTooltipClass="accent"
			matRipple
		>
			<div class="selectionIndicator" [class.visible]="selected()"></div>
			<ng-container *ngTemplateOutlet="content" />
		</div>
	}
} @else {
	<div [class.invalid]="invalid()" class="listItem nonSelect">
		<ng-container *ngTemplateOutlet="content" />
	</div>
}

<ng-template #content>
	<div class="defaultWrapper">
		<ng-content select="[indicator]" />
		<div class="indicator default">
			@if (indicatorIcon()) {
				<mat-icon [fontIcon]="indicatorIcon()!.fontIcon" [fontSet]="indicatorIcon()!.fontSet" />
			} @else {
				{{ indicator() }}
			}
		</div>
	</div>
	<div class="labels">
		<label class="primaryLabel">{{ primaryLabel() }}</label>

		@if (secondaryLabel()) {
			<label class="secondary">
				@if (secondaryLabelIcon()) {
					<mat-icon [fontIcon]="secondaryLabelIcon()!.fontIcon" [fontSet]="secondaryLabelIcon()!.fontSet" inline />
				}
				{{ secondaryLabel() }}
			</label>
		} @else {
			<ng-content select="[secondary]" />
		}
	</div>
	<div class="actions">
		<ng-content select="[actions]" />
	</div>
</ng-template>
